import { c as _c } from "react/compiler-runtime";
export function SparkHero() {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute inset-x-0 top-0 h-1.5 bg-[#ff8a3d]" />;
    t1 = <div aria-hidden="true" className="absolute inset-0 opacity-[0.12] [background-image:linear-gradient(to_right,white_1px,transparent_1px),linear-gradient(to_bottom,white_1px,transparent_1px)] [background-size:54px_54px] [mask-image:linear-gradient(to_bottom,black,transparent_85%)]" />;
    t2 = <div aria-hidden="true" className="absolute -right-32 -top-32 h-96 w-96 rounded-full bg-[#ff8a3d]/25 blur-3xl" />;
    t3 = <div aria-hidden="true" className="absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-[#ffc857]/15 blur-3xl" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <section className="relative isolate overflow-hidden border-b border-white/10 bg-[#211d4f] text-white">{t0}{t1}{t2}{t3}<div className="relative mx-auto max-w-[1440px] px-5 py-10 sm:px-8 sm:py-12 lg:px-12 lg:py-14"><h1 className="max-w-5xl text-4xl font-black leading-[0.94] tracking-[-0.045em] sm:text-5xl lg:text-6xl">Spark: Get Inspired,<span className="block text-[#ffc857]">Take Action.</span></h1><p className="mt-4 max-w-3xl text-xl font-bold leading-tight text-white sm:text-2xl lg:text-[1.75rem]">Real examples, playbooks, and ready-to-use starters.</p><p className="mt-3 max-w-2xl text-base leading-7 text-white/70 sm:text-lg">See what others have done, learn how they did it, then launch your own initiative with confidence.</p></div></section>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}